import i18n from "i18n/config";
import { formatDateDisplay } from "shared/components/input/date/DateInputUtils";
import { formatIsoDateToDisplay } from "shared/utils/DateUtils";
import * as yup from "yup";

// Must happen before any schemas are created, see:
//  https://github.com/jquense/yup/issues/293 !
export const appInitYup = () => {
  yup.setLocale({
    array: {
      max: ({ max }) => i18n.t("errors:arrayMax", { count: max }),
      min: ({ min }) => i18n.t("errors:arrayMin", { count: min }),
    },
    mixed: {
      oneOf: () => i18n.t("errors:required"),
      defined: () => i18n.t("errors:required"),
      required: () => i18n.t("errors:required"),
      notNull: () => i18n.t("errors:required"),
      notType: ({ type, originalValue }) =>
        originalValue
          ? i18n.t("errors:notType", { type })
          : i18n.t("errors:required"),
    },
    number: {
      max: ({ max }) => i18n.t("errors:numberMax", { max }),
      min: ({ min }) => i18n.t("errors:numberMin", { min }),
      negative: () => i18n.t("errors:numberNeg"),
      positive: () => i18n.t("errors:numberPos"),
    },
    string: {
      max: ({ max }) => i18n.t("errors:stringMax", { max }),
      min: ({ min }) => i18n.t("errors:stringMin", { min }),
      matches: () => i18n.t("errors:stringMatches"),
    },
    date: {
      max: ({ max }) =>
        i18n.t("errors:dateMax", { max: formatDateOrString(max) }),
      min: ({ min }) =>
        i18n.t("errors:dateMin", { min: formatDateOrString(min) }),
    },
  });
};

const formatDateOrString = (value: Date | string) =>
  value instanceof Date
    ? formatDateDisplay(value)
    : formatIsoDateToDisplay(value);
